import { render, staticRenderFns } from "./PropertyFileModal.vue?vue&type=template&id=2d6b5431&scoped=true&"
import script from "./PropertyFileModal.vue?vue&type=script&lang=js&"
export * from "./PropertyFileModal.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFileModal.vue?vue&type=style&index=0&id=2d6b5431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b5431",
  null
  
)

export default component.exports